import createVueComponent from '../createVueComponent';

const StepBack = createVueComponent('StepBackIcon', [
  ['line', { x1: '18', x2: '18', y1: '20', y2: '4', key: 'cun8e5' }],
  ['polygon', { points: '14,20 4,12 14,4', key: 'ypakod' }],
]);

export default StepBack;
